import { ShotlistsService } from '@/services/shotlist.service'

import { ILanguage } from '@/types/task.interface'

export const uploadSrtShotlist = async ({
	taskId,
	selectedSrtFile,
	selectedSrtLang
}: {
	taskId: string
	selectedSrtFile: File
	selectedSrtLang: ILanguage | null
}) => {
	if (!taskId || !selectedSrtFile || !selectedSrtLang?.code) return

	await ShotlistsService.uploadSrtFile(
		taskId,
		selectedSrtFile,
		selectedSrtLang.code,
		selectedSrtFile.name
	)
	await ShotlistsService.changeOriginalLanguage(taskId, selectedSrtLang.code)
}
